if ($('.pagination__news')[0]) {
    console.log('heya');
}
